import { supabase } from './supabaseClient';

/** Solicitar conexion con otro usuario */
export async function solicitarConexion(toUserId) {
  const { data: { user } } = await supabase.auth.getUser();
  if (!user) return { error: 'No autenticado' };

  const { data, error } = await supabase.from('conexiones').insert({
    user_from_id: user.id,
    user_to_id: toUserId,
    estado: 'pendiente',
  }).select().single();

  return { data, error };
}

/** Aceptar o rechazar solicitud */
export async function responderConexion(conexionId, estado) {
  const { data, error } = await supabase.from('conexiones')
    .update({ estado, responded_at: new Date().toISOString() })
    .eq('id', conexionId)
    .select().single();
  return { data, error };
}

/** Obtener todas mis conexiones */
export async function obtenerConexiones(userId) {
  const { data, error } = await supabase
    .from('conexiones')
    .select('*, from:profiles!conexiones_user_from_id_fkey(id, full_name, business_name, avatar_url, business_type), to:profiles!conexiones_user_to_id_fkey(id, full_name, business_name, avatar_url, business_type)')
    .or(`user_from_id.eq.${userId},user_to_id.eq.${userId}`)
    .order('created_at', { ascending: false });
  return { data: data || [], error };
}

/** Obtener estado de conexion entre 2 usuarios */
export async function estadoConexion(userId, otroId) {
  const { data } = await supabase
    .from('conexiones')
    .select('id, estado, user_from_id, user_to_id')
    .or(`and(user_from_id.eq.${userId},user_to_id.eq.${otroId}),and(user_from_id.eq.${otroId},user_to_id.eq.${userId})`)
    .maybeSingle();
  return data;
}

/** Contar solicitudes pendientes que me llegaron */
export async function contarPendientes(userId) {
  const { count } = await supabase
    .from('conexiones')
    .select('id', { count: 'exact', head: true })
    .eq('user_to_id', userId)
    .eq('estado', 'pendiente');
  return count || 0;
}

/** Contar mensajes no leidos */
export async function contarNoLeidos(userId) {
  const { data: misConexiones } = await supabase
    .from('conexiones')
    .select('id')
    .eq('estado', 'aceptada')
    .or(`user_from_id.eq.${userId},user_to_id.eq.${userId}`);

  if (!misConexiones || misConexiones.length === 0) return 0;

  const { count } = await supabase
    .from('mensajes')
    .select('id', { count: 'exact', head: true })
    .in('conexion_id', misConexiones.map(c => c.id))
    .neq('user_from_id', userId)
    .eq('leido', false);

  return count || 0;
}
